// Invalidates asynchronous sign-in/renewal work when the user signs out.
const KEY = 'camptain.signedOut';
let generation = 0;
let signedOut = false;
export const sessionGeneration = () => generation;
export function hasSignedOut(): boolean {
  try {
    return signedOut || sessionStorage.getItem(KEY) === 'true';
  } catch {
    return signedOut;
  }
}
export function beginSignIn(): number {
  signedOut = false;
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* storage unavailable */
  }
  return ++generation;
}
export function beginSignOut(): void {
  signedOut = true;
  ++generation;
  try {
    sessionStorage.setItem(KEY, 'true');
  } catch {
    /* storage unavailable */
  }
}
export const sessionIsCurrent = (attempt: number) => attempt === generation && !hasSignedOut();
